module.exports = __webpack_public_path__ + "static/riley-6-b043a83c47d99bc2919fb12cf0e9a654.jpg";